import { SVGProps } from "react";

export default function TextIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, stroke = "currentColor", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.33594 4.08563V3.17562C1.33594 2.60062 1.80094 2.14062 2.37094 2.14062H9.63094C10.2059 2.14062 10.6659 2.60562 10.6659 3.17562V4.08563"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10.8597V2.55469"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.03125 10.8594H7.97125"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
